import styled from 'styled-components';
import {
  Box,
  Stepper as MUIStepper,
  Step as MUIStep,
  StepLabel as MUIStepLabel,
  StepLabelProps,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

export const Container = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  position: relative;
  row-gap: ${({ theme }) => theme.spacing(2)};

  @media (min-width: 950px) {
    flex-direction: row;
  }
`;

export const Stepper = styled(MUIStepper)`
  width: 100%;
  max-width: 650px;

  @media (min-width: 1000px) {
    max-width: 700px;
  }

  @media (min-width: 1200px) {
    max-width: 800px;
  }
`;

export const LogoWrapper = styled(Box)`
  transform: scale(0.8);

  @media (min-width: 950px) {
    position: absolute;
    left: 87%;
    top: -5px;
  }

  @media (min-width: 1000px) {
    transform: scale(0.9);
  }

  @media (min-width: 1200px) {
    left: 85%;
    transform: scale(1);
  }
`;

export const Step = styled(MUIStep)`
  svg {
    &.Mui-completed {
      fill: ${({ theme }) => theme.palette.success.main};
    }
    &.Mui-active {
      fill: ${({ theme }) => theme.palette.primary.main};
    }
    &.Mui-disabled {
      fill: ${({ theme }) => theme.palette.grey[200]};
    }
  }
`;

export const StepLabel = styled(MUIStepLabel)<StepLabelProps>`
  .Mui-error {
    fill: ${({ theme }) => theme.palette.error.main} !important;

    svg {
      height: 27px;
      width: 27px;
    }
  }
  display: flex;
  text-transform: capitalize;

  p {
    color: ${({ theme, error }) =>
      error ? theme.palette.error.main : theme.palette.grey[700]} !important;
  }
`;

export const SummaryLabelWrapper = styled(Box)`
  display: flex;
  align-items: center;
  position: absolute;
`;

export const SummaryLabel = styled(Typography)`
  font-size: 10px !important;
  letter-spacing: 0.1px;
`;

export const StepIcon = styled(EditIcon)`
  font-size: 10px !important;
  margin-left: ${({ theme }) => theme.spacing(0.5)};
`;

export const ErrorMessage = styled(Typography)`
  font-size: 10px !important;
  color: ${({ theme }) => theme.palette.error.main};
`;
